/* =====================================================================
   Onion cart drawer — v2 JS
   • "+ Add" on upsell cards (resolves the picked Color/Size to a variant)
   • "Buy 2 for $X" chip (sets that line to qty 2; the native discount does the rest)
   • Social-proof bubble on any add-to-cart
   • Product-page bundle widget
   All updates re-render the drawer through Dawn's own <cart-drawer>.renderContents().
   ===================================================================== */
(function () {
  'use strict';
  // The file can be included by both the cart drawer and the product-page widget — run once.
  if (window.__onionCartLoaded) return;
  window.__onionCartLoaded = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SOCIAL_PROOF = false;         // set to true to turn the bubble on
  var CITIES = ['Ontario'];         // add more to rotate, e.g. ['Ontario','Toronto','Vancouver']

  function drawer() { return document.querySelector('cart-drawer'); }

  // Dawn's newer builds key sections by `id`, older ones by `section` — support both.
  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id || s.section; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refresh(data) {
    var d = drawer();
    if (d && typeof d.renderContents === 'function' && data && data.sections) {
      // Dawn hides rows while the drawer has `is-empty`; keep it in sync (add.js replies carry no item_count)
      d.classList.toggle('is-empty', typeof data.item_count === 'number' && data.item_count === 0);
      d.renderContents(data);
    } else {
      window.location.href = ROOT + 'cart';
    }
  }

  function post(path, body) {
    body.sections = sectionIds();
    body.sections_url = window.location.pathname;
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }

  /* ---- Upsell cards: resolve selected options → variant ---- */
  function cardVariant(card) {
    var node = card.querySelector('[data-onion-variants]');
    if (!node) return null;
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (e) { return null; }
    var sels = card.querySelectorAll('.onion-up-sel');
    if (!sels.length) return variants[0] || null;
    var picked = Array.prototype.map.call(sels, function (s) { return s.value; });
    return variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === picked[i]; });
    })[0] || null;
  }

  function syncCard(card) {
    var btn = card.querySelector('[data-onion-add]');
    var v = cardVariant(card);
    if (!v || !v.available) { btn.disabled = true; btn.textContent = 'Sold out'; }
    else { btn.disabled = false; btn.textContent = btn.getAttribute('data-label') || '+ Add'; btn.setAttribute('data-variant', v.id); }
  }

  // Capture phase + stop: Dawn's cart code also listens for 'change' inside the drawer and would treat
  // our Color/Size pickers as quantity boxes ("increments of undefined" popup).
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('onion-up-sel')) {
      e.stopImmediatePropagation();
      syncCard(e.target.closest('[data-onion-card]'));
    }
  }, true);

  // Colour dots (empty-cart cards): pick the dot -> set the hidden select -> same variant logic as the dropdowns
  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('[data-onion-swatch]');
    if (!dot) return;
    e.preventDefault();
    var field = dot.closest('.onion-dots-field');
    var sel = field && field.querySelector('select');
    if (!sel) return;
    Array.prototype.forEach.call(field.querySelectorAll('[data-onion-swatch]'), function (d) {
      var on = d === dot;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var name = field.querySelector('.onion-dots__name');
    if (name) name.textContent = dot.getAttribute('data-onion-swatch');
    sel.value = dot.getAttribute('data-onion-swatch');
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    // colour picked -> show that colour's photo (the variant image set in Shopify)
    if (dot.classList.contains('onion-opt--color')) {
      var card = dot.closest('[data-onion-card]');
      var img = card && card.querySelector('[data-onion-card-img]');
      var node = card && card.querySelector('[data-onion-variants]');
      if (img && node) {
        try {
          var val = dot.getAttribute('data-onion-swatch');
          var match = JSON.parse(node.textContent).filter(function (x) {
            return x.featured_image && x.options.indexOf(val) > -1;
          })[0];
          if (match) {
            var src = match.featured_image.src;
            img.removeAttribute('srcset');
            img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
            if (match.featured_image.alt) img.alt = match.featured_image.alt;
          }
        } catch (err) {}
      }
    }
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var add = e.target.closest('[data-onion-add]');
    if (add && !add.disabled) {
      e.preventDefault();
      var card = add.closest('[data-onion-card]');
      var v = cardVariant(card);
      if (!v || !v.available) { syncCard(card); return; }
      add.disabled = true; add.textContent = 'Adding…';
      post('cart/add.js', { items: [{ id: v.id, quantity: 1 }] })
        .then(refresh)
        .catch(function (err) {
          add.disabled = false;
          add.textContent = (err && err.description) ? 'Unavailable' : 'Try again';
        });
      return;
    }

    var pair = e.target.closest('[data-onion-pair]');
    if (pair && !pair.disabled) {
      e.preventDefault();
      pair.disabled = true;
      post('cart/change.js', { id: pair.getAttribute('data-onion-pair'), quantity: 2 })
        .then(refresh)
        .catch(function () { pair.disabled = false; });
    }
  });

  /* ---- Social-proof bubble ---- */
  var bubbleTimer;
  function showBubble(src) {
    var bubble = document.getElementById('OnionBubble');
    var d = drawer();
    if (!bubble || !d || !d.classList.contains('active')) return; // only while the drawer is open
    if (src) document.getElementById('OnionBubbleImg').src = src;
    document.getElementById('OnionBubbleWho').textContent = CITIES[Math.floor(Math.random() * CITIES.length)];
    bubble.classList.add('is-visible');
    clearTimeout(bubbleTimer);
    bubbleTimer = setTimeout(function () { bubble.classList.remove('is-visible'); }, 4500);
  }

  function bubbleFor(variantId) {
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return String(i.variant_id) === String(variantId); })[0]
          || cart.items[0];
        var img = line && line.image ? line.image + (line.image.indexOf('?') > -1 ? '&' : '?') + 'width=80' : '';
        showBubble(img);
      })
      .catch(function () { showBubble(''); });
  }

  /* ---- Product page bundle widget: pick colour/size for #1 and #2, add both ---- */
  function obPick(item, variants) {
    var sels = item.querySelectorAll('.ob-sel');
    var vals = Array.prototype.map.call(sels, function (s) { return s.value; });
    Array.prototype.forEach.call(sels, function (s) { s.classList.toggle('ob-sel--error', !s.value); });
    if (vals.some(function (v) { return !v; })) return { error: 'Please select a colour and size for each item.' };
    var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); })[0];
    if (!v || !v.available) return { error: 'Sorry, ' + vals.join(' / ') + ' is sold out — try another option.' };
    return { variant: v };
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var toggle = e.target.closest('[data-ob-toggle]');
    if (toggle) {
      var body = toggle.closest('[data-onion-bundle]').querySelector('[data-ob-body]');
      var open = body.hasAttribute('hidden');
      if (open) body.removeAttribute('hidden'); else body.setAttribute('hidden', '');
      toggle.textContent = open ? 'Hide' : 'Show';
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    var btn = e.target.closest('[data-ob-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var widget = btn.closest('[data-onion-bundle]');
    var msg = widget.querySelector('[data-ob-msg]');
    var variants;
    try { variants = JSON.parse(widget.querySelector('[data-ob-variants]').textContent); } catch (err) { return; }

    var items = widget.querySelectorAll('[data-ob-item]');
    var picks = [];
    if (!items.length) { picks.push({ variant: variants[0] }, { variant: variants[0] }); } // product without options
    for (var i = 0; i < items.length; i++) {
      var r = obPick(items[i], variants);
      if (r.error) { msg.textContent = r.error; msg.hidden = false; return; }
      picks.push(r);
    }
    msg.hidden = true;

    // same variant twice → one line, qty 2; different colours/sizes → two lines
    var byId = {};
    picks.forEach(function (p) { byId[p.variant.id] = (byId[p.variant.id] || 0) + 1; });
    var payload = Object.keys(byId).map(function (id) { return { id: Number(id), quantity: byId[id] }; });

    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'adding…';
    post('cart/add.js', { items: payload })
      .then(function (data) { btn.disabled = false; btn.textContent = label; refresh(data); })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        msg.textContent = (err && err.description) || 'Something went wrong — please try again.';
        msg.hidden = false;
      });
  });

  /* ---- Combined rows: one row stands for every cart line of the same variant ---- */
  // Shopify puts the Buy-2 "get" unit on its own line. The drawer shows those lines as one row
  // (data-onion-group="1,2"); its +/-/remove set the variant's TOTAL, and Shopify re-splits as needed.
  function setGroupTotal(row, total) {
    var lines = row.getAttribute('data-onion-group').split(',').map(Number);
    row.style.opacity = '.55';
    fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = cart.items.map(function (i) { return i.quantity; });
        lines.forEach(function (n, k) { updates[n - 1] = k === 0 ? Math.max(total, 0) : 0; });
        return post('cart/update.js', { updates: updates });
      })
      .then(refresh)
      .catch(function () { row.style.opacity = ''; });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest || !t.classList || !t.classList.contains('quantity__input')) return;
    var row = t.closest('[data-onion-group]');
    if (!row) return;
    e.stopImmediatePropagation(); // keep Dawn from changing just the first line
    setGroupTotal(row, parseInt(t.value, 10) || 0);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var rm = e.target.closest('cart-remove-button');
    var row = rm && rm.closest('[data-onion-group]');
    if (!row) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    setGroupTotal(row, 0);
  }, true);

  // Catch every add-to-cart (product pages, quick add, our upsell) without touching other theme code.
  if (SOCIAL_PROOF) {
    var nativeFetch = window.fetch;
    window.fetch = function () {
      var req = arguments[0];
      var url = (req && req.url) || req || '';
      var p = nativeFetch.apply(this, arguments);
      if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
        p.then(function (res) {
          if (!res.ok) return;
          res.clone().json().then(function (d) {
            var vid = d && (d.variant_id || (d.items && d.items[0] && d.items[0].variant_id) || d.id);
            setTimeout(function () { bubbleFor(vid); }, 600);
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }
})();
